import { useEffect, useState } from "react";
import api from "../../lib/api";
import { apiErrorMessage } from "../../lib/apiErrors";

const fmt = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
};

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get("/leads")
      .then((r) => {
        setLeads(r.data);
        setError("");
      })
      .catch((err) => {
        setLeads([]);
        setError(apiErrorMessage(err, "Could not load leads"));
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="mb-8">
        <h1 className="font-serif-display text-4xl">Leads</h1>
        <p className="text-muted-foreground text-sm mt-1">
          Enquiries from contact form, calculator, and chatbot ({leads.length}).
        </p>
      </div>

      {error && (
        <p className="mb-4 text-sm text-destructive rounded-xl border border-destructive/30 bg-destructive/10 px-4 py-3">{error}</p>
      )}

      {loading ? (
        <p className="text-muted-foreground">Loading…</p>
      ) : leads.length === 0 ? (
        <p className="text-muted-foreground rounded-2xl border border-border p-8 text-center">No leads yet.</p>
      ) : (
        <div className="rounded-2xl border border-border overflow-x-auto">
          <table className="w-full text-sm min-w-[720px]">
            <thead>
              <tr className="border-b border-border bg-secondary/40 text-left">
                <th className="p-3 font-medium">When</th>
                <th className="p-3 font-medium">Name</th>
                <th className="p-3 font-medium">Mobile</th>
                <th className="p-3 font-medium">Email</th>
                <th className="p-3 font-medium">Source</th>
                <th className="p-3 font-medium">Details</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((l) => (
                <tr key={l.id} className="border-b border-border last:border-0 hover:bg-secondary/30">
                  <td className="p-3 text-muted-foreground whitespace-nowrap">{fmt(l.created_at)}</td>
                  <td className="p-3 font-medium">{l.name || "—"}</td>
                  <td className="p-3">{l.mobile || "—"}</td>
                  <td className="p-3">{l.email || "—"}</td>
                  <td className="p-3 capitalize">{l.source || "—"}</td>
                  <td className="p-3 text-muted-foreground max-w-xs truncate" title={l.message || ""}>
                    {[l.city, l.package, l.area ? `${l.area} sq.ft` : null, l.message].filter(Boolean).join(" · ") || "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
